import React from "react";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
} from "@material-ui/core";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import CurrencyInput from "../../../../components/currency-input";

export default function QuickGlassModal({
    open,
    loading,
    values,
    brands,
    colors,
    categories,
    onChange,
    onClose,
    onSubmit,
}) {
    const updateValue = (updates) => {
        onChange((prev) => ({
            ...prev,
            ...updates,
        }));
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>ایجاد عینک جدید</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="نام عینک"
                            value={values.name}
                            onChange={(event) => updateValue({ name: event.target.value })}
                            autoFocus
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MuiAutocomplete
                            options={categories}
                            value={
                                categories.find((entry) => entry.value === values.category) ||
                                null
                            }
                            onChange={(event, value) =>
                                updateValue({ category: value?.value || "" })
                            }
                            getOptionSelected={(option, value) =>
                                option.value === value.value
                            }
                            getOptionLabel={(option) => option?.title || ""}
                            noOptionsText="نوعی ثبت نشده."
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    variant="outlined"
                                    label="نوع"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <MuiAutocomplete
                            options={brands}
                            value={
                                brands.find((entry) => entry.id === values.brandId) ||
                                null
                            }
                            onChange={(event, value) =>
                                updateValue({ brandId: value?.id || "" })
                            }
                            getOptionSelected={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option?.name || ""}
                            noOptionsText="برندی ثبت نشده."
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    variant="outlined"
                                    label="برند"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="نام رنگ"
                            value={values.colorName}
                            onChange={(event) =>
                                updateValue({ colorName: event.target.value })
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MuiAutocomplete
                            options={colors}
                            value={
                                colors.find((entry) => entry.id === values.colorId) ||
                                null
                            }
                            onChange={(event, value) =>
                                updateValue({
                                    colorId: value?.id || "",
                                    colorValue: values.colorValue || value?.color || "",
                                })
                            }
                            getOptionSelected={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option?.name || ""}
                            noOptionsText="رنگی ثبت نشده."
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    variant="outlined"
                                    label="رنگ پایه"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="کد رنگ"
                            value={values.colorValue}
                            onChange={(event) =>
                                updateValue({ colorValue: event.target.value })
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="قیمت"
                            value={values.price}
                            onChange={(event) => updateValue({ price: event.target.value })}
                            InputProps={{ inputComponent: CurrencyInput }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    انصراف
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={onSubmit}
                    disabled={loading}
                    startIcon={
                        loading ? <CircularProgress size={18} color="inherit" /> : null
                    }
                >
                    ایجاد عینک
                </Button>
            </DialogActions>
        </Dialog>
    );
}
